window.Autocomplete = {
	
	instances		: [],
	defaultOptions	: {
		preventDuplicates	: true,
		hintText 			: Loc.g('Veuillez saisir quelques caractères'),
		noResultsText		: Loc.g('Aucun résultat'),
		searchingText		: Loc.g('Recherche en cours...'),
		queryParam 			: 'value',
		jsonContainer 		: 'results',
		searchOnFocus		: false,
		tokenLimit			: false,
		minChars			: 1,
		placeholderText		: Loc.g('Rechercher'),
	},
	
	third : function($elmt, customOptions){
		
		
		var attrOpts	= Autocomplete.getAttrOptions($elmt);

		var baseOptions = {
			page			: 'thirds',
			action			: 'search',
			allowCustomEntry: false,
			hintText		: Loc.g("Saisissez un nom, identifiant, numéro de téléphone"),
			tokenValue		: 'id',
			propertyToSearch: 'name',
			prePopulate		: $elmt.data('populate'),
			queryParam		: 'q'

		};
		
		baseOptions.resultsFormatter = function (item) {
			if (item.ident === null) {
				item.ident = '';
			}
			var relationTypeFormatted = item.relationType;
			switch (item.relationType){
				case 'client':
                    relationTypeFormatted = Loc.g("Client");
					break;
                case 'prospect':
                    relationTypeFormatted = Loc.g("Prospect");
                    break;
                case 'supplier':
                    relationTypeFormatted = Loc.g("Fournisseur");
                    break;

			}

			var htmlFormater = '<li style="display:table;" class="ac-item wp-10">';
			htmlFormater += "<div class='auto_item_pc' style='display:table-cell;width:40px;text-align:center; vertical-align: middle;'>";
			if (item.avatar.type == 'initials') {
				htmlFormater += '<span class="avatar mr-1">'
						+ '	' + item.avatar.value
						+ '</span>';
			} else {
				htmlFormater += '<span class="avatar avatar-picture">'
						+ '	<img src="' + item.avatar.value + '" />'
						+ '</span>';
			}
			htmlFormater += "</div>";
			htmlFormater += '<div style="display:table-cell;vertical-align:middle;">';
			htmlFormater += '<div class="name ml-3 fs-3">' + item.name + '</div>';
			htmlFormater += '<table class="ac-table-selectize ml-3">';
			htmlFormater += '<thead>';
			htmlFormater += '<tr>';
			htmlFormater += '<th>';
			htmlFormater += '<div class="info gray-60 ellipsis"><span class="info-label label-xsmall fs-2">Type</span></div>';
			htmlFormater += '</th>';
			if(item.fullName != ''){
				htmlFormater += '<th class="ellipsis" style="width: 100px;">';
				htmlFormater += '<div class="info gray-60 ellipsis"><span class="info-label label-xsmall fs-2">Contact</span></div>';
				htmlFormater += '</th>';
			}
			htmlFormater += '</tr>';
			htmlFormater += '</thead>';
            htmlFormater += '<tbody>';
            htmlFormater += '<tr>';
            htmlFormater += '<td>';
            htmlFormater += '<div class="info ellipsis"><span class="info-value fs-2">' + relationTypeFormatted + '</span></div>';
            htmlFormater += '</td>';
			
			if(item.fullName != ''){
				htmlFormater += '<td>';
				htmlFormater += '<div class="info ellipsis" style="width: 110px;"><span class="info-value fs-2">' + item.fullName + '</span></div>';
				htmlFormater += '</td>';
			}
            htmlFormater += '</tr>';
            htmlFormater += '</tbody>';
			htmlFormater += "</table>";
			htmlFormater += "</div>";
			htmlFormater += '</li>';

			return htmlFormater;
		};

		var options = $.extend({}, baseOptions, Autocomplete.getAttrOptions($elmt), customOptions);
		
		Autocomplete.init($elmt, options);
	},
	
	
	doc : function($elmt, customOptions){
		

		var baseOptions = {
			page				: 'docs',
			action				: 'search',
			allowCustomEntry	: false,
			hintText			: Loc.g("Saisissez un identifiant, objet de document"),
			tokenValue			: 'id',
			propertyToSearch	: 'ident',
			prePopulate			: $elmt.data('populate'),
			queryParam			: 'q',

		};


		baseOptions.resultsFormatter = function(item) {

			var htmlFormater	= '<li class="autoDoc ac-item">';
			htmlFormater		+= '<span class="name">' + item.ident + '</span>';

            htmlFormater += '<table class="ac-table-selectize">';
            htmlFormater += '<thead>';
            htmlFormater += '<tr>';
            if(item.thirdname !== null) {
                htmlFormater += '<th>';
                htmlFormater += '<div class="info gray-60 ellipsis"><span class="info-label label-small fs-2">' + Loc.g('Client') + '</span></div>';
                htmlFormater += '</th>';
            }
            if (item.subject != "") {
                htmlFormater += '<th>';
                htmlFormater += '<div class="info gray-60 ellipsis"><span class="info-label label-small fs-2">' + Loc.g('Objet') + '</span></div>';
                htmlFormater += '</th>';
            }
            htmlFormater += '<th>';
            htmlFormater += '<div class="info gray-60 ellipsis"><span class="info-label label-small fs-2">' + Loc.g('Montant') + '</span></div>';
            htmlFormater += '</th>';
            htmlFormater += '</tr>';
            htmlFormater += '</thead>';
            htmlFormater += '<tbody>';
            htmlFormater += '<tr>';
            if(item.thirdname !== null) {
                htmlFormater += '<td>';
                htmlFormater += '<div class="info ellipsis" style="width: 100px;"><span class="info-value fs-2">' + item.thirdname + '</span></div>';
                htmlFormater += '</td>';
            }
            if (item.subject != "") {
                htmlFormater += '<td>';
                htmlFormater += '<div class="info ellipsis" style="width: 120px;"><span class="info-value fs-2">' + item.subject + '</span></div>';
                htmlFormater += '</td>';
            }
            htmlFormater += '<td>';
            htmlFormater += '<div class="info ellipsis" style="width: 120px;"><span class="info-value fs-2">' + item.formatted_totalAmount + '</span></div>';
            htmlFormater += '</td>';
            htmlFormater += '</tr>';
            htmlFormater += '</tbody>';
            htmlFormater += "</table>";

			htmlFormater	+= '</li>';

			return htmlFormater;
		};
			
		var options = $.extend({}, baseOptions, Autocomplete.getAttrOptions($elmt), customOptions);
		
		Autocomplete.init($elmt, options);
		
	},
	
	
	getAttrOptions : function($elmt){
		
		var attrOpts = {};
		
		if($elmt.attr('ac-maxitems') != undefined){
			attrOpts.tokenLimit = $elmt.attr('ac-maxitems');
		}
		
		if($elmt.attr('ac-filter') != undefined){
			attrOpts.url = "&filter="+$elmt.attr('ac-filter');
		}else{
			attrOpts.url = "";
		}
		
		if($elmt.attr('ac-autosearch') != undefined){
			attrOpts.searchOnFocus = $elmt.attr('ac-autosearch');
		}
		
		if($elmt.attr('placeholder') != undefined){
			attrOpts.placeholderText = $elmt.attr('placeholder');
		}
		
		return attrOpts;
	},

	init : function($elmt, options){
		// DEFAULT OPTIONS
		
		var opts = $.extend({}, Autocomplete.defaultOptions, options);
		
		if(opts.page == undefined || opts.page == ''){
			console.error('[Autocomplete] No backend action configured');
			return false;
		}
		
		Autocomplete.instances[$elmt.attr('id')] = $elmt.tokenInput('/?_f='+opts.page+''+opts.url, opts);
	}
}